import { render, staticRenderFns } from "./Liondesk.vue?vue&type=template&id=83d9cf6a"
import script from "./Liondesk.vue?vue&type=script&lang=js"
export * from "./Liondesk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports